(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("himalaya"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "himalaya"], factory);
	else if(typeof exports === 'object')
		exports["safelySetInnerHTML"] = factory(require("react"), require("himalaya"));
	else
		root["safelySetInnerHTML"] = factory(root["react"], root["himalaya"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _himalaya = __webpack_require__(2);

var _warning = __webpack_require__(3);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SafelySetInnerHTML = function () {
  /**
   * safelySetInnerHTML
   * @param config
   */
  function SafelySetInnerHTML(config) {
    _classCallCheck(this, SafelySetInnerHTML);

    this.config = _extends({}, SafelySetInnerHTML.defaultConfig, config);
    this.tagId = 0;
    this.cache = [];

    this.generateDom = this.generateDom.bind(this);
    this.transform = this.transform.bind(this);
    this.getCache = this.getCache.bind(this);
    this.formatAttributes = this.formatAttributes.bind(this);
  }

  /**
   * Filter and format allowed attributes in order to return an object of props
   * for the currently rendered React tag
   * @param attributes - from himalaya syntax
   * @returns {object}
   */


  _createClass(SafelySetInnerHTML, [{
    key: 'formatAttributes',
    value: function formatAttributes(attributes) {
      var _this = this;

      var props = {};

      attributes.filter(function (_ref) {
        var key = _ref.key;
        return _this.config.ALLOWED_ATTRIBUTES.includes(key);
      }).forEach(function (_ref2) {
        var key = _ref2.key,
            value = _ref2.value;

        (0, _warning2.default)(key);
        props[key] = value;
      });

      return props;
    }

    /**
     * Based on himalaya api, recursive function used to generate the react dom
     * @param type - type type (can be : root, element, content)
     * @param children - if the current type has children, it will be a filled array
     * @param content - if the current type has content
     * @param tagName - if the current type is a tagName
     * @param attributes - if the current type has html attributes
     * @param allowedTags - map of authorized tags
     * @returns {Object}
     */

  }, {
    key: 'generateDom',
    value: function generateDom(_ref3) {
      var _ref3$type = _ref3.type,
          type = _ref3$type === undefined ? '' : _ref3$type,
          _ref3$children = _ref3.children,
          children = _ref3$children === undefined ? [] : _ref3$children,
          _ref3$content = _ref3.content,
          content = _ref3$content === undefined ? '' : _ref3$content,
          _ref3$tagName = _ref3.tagName,
          tagName = _ref3$tagName === undefined ? '' : _ref3$tagName,
          _ref3$attributes = _ref3.attributes,
          attributes = _ref3$attributes === undefined ? [] : _ref3$attributes;
      var _config = this.config,
          ALLOWED_TAGS = _config.ALLOWED_TAGS,
          KEY_NAME = _config.KEY_NAME;
      // Group children and content case in one reference

      var innerContent = children.length ? children.map(this.generateDom) : content;

      if (type === 'element' && ALLOWED_TAGS.includes(tagName)) {
        (0, _warning2.default)(tagName);
        var props = _extends({}, this.formatAttributes(attributes), {
          key: '' + KEY_NAME + this.tagId++
        });

        if (!innerContent) {
          return _react2.default.createElement(tagName, props);
        }

        return _react2.default.createElement(tagName, props, innerContent);
      }

      return innerContent;
    }
  }, {
    key: 'getCache',


    /**
     * Find in cache if the given str exists
     * @param str
     * @returns {*}
     */
    value: function getCache(str) {
      return this.cache.find(function (entry) {
        return entry.str === str;
      });
    }

    /**
     * Basic API, will transform the given string in React DOM
     * @param str - html string to transform
     * @returns {Object}
     */

  }, {
    key: 'transform',
    value: function transform(str) {
      // Retrieve cache
      var foundCache = this.getCache(str);

      if (foundCache) {
        return foundCache.dom;
      }

      // Process dom generation
      var dom = (0, _himalaya.parse)(str).map(this.generateDom);

      // Store in cache
      this.cache.push({ str: str, dom: dom });

      return dom;
    }
  }]);

  return SafelySetInnerHTML;
}();

/**
 * Default config
 * @type {{ALLOWED_TAGS: string[], ALLOWED_ATTRIBUTES: string[], KEY_NAME: string}}
 */


SafelySetInnerHTML.defaultConfig = {
  ALLOWED_TAGS: ['strong', 'a'],
  ALLOWED_ATTRIBUTES: ['href'],
  KEY_NAME: 'ssih-tag-'
};

exports.default = SafelySetInnerHTML;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (attributeOrTag) {
  if (attributeOrTag in messages.attributes) {
    console.warn(messages.attributes[attributeOrTag].replace('%s', 'attribute ' + attributeOrTag));
  }

  if (attributeOrTag in messages.tags) {
    console.warn(messages.tags[attributeOrTag].replace('%s', 'tag <' + attributeOrTag + ' />'));
  }
};

var XSS_ATTACK = 'Be careful with the use of %s, it presents a potential XSS risk';

var messages = exports.messages = {
  attributes: {
    ontransitionend: XSS_ATTACK,
    ontransitioncancel: XSS_ATTACK,
    onblur: XSS_ATTACK,
    ondrag: XSS_ATTACK,
    ondrop: XSS_ATTACK
  },
  tags: {
    script: XSS_ATTACK,
    style: XSS_ATTACK
  }
};

/***/ })
/******/ ]);
});